// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../common/Components/Loader.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertiesPageRelay = require("./PropertiesPageRelay.bs.js");
let PropertiesPageRelayMapLazy = require("./PropertiesPageRelayMapLazy.bs.js");

function PropertiesPageRelayFeatureGate(props) {
  if (FeaturesV3.usePropertySearchMapEnabled()) {
    return JsxRuntime.jsx(React.Suspense, {
      children: JsxRuntime.jsx(PropertiesPageRelayMapLazy.make, {}),
      fallback: JsxRuntime.jsx(Loader.make, {})
    });
  } else {
    return JsxRuntime.jsx(PropertiesPageRelay.make, {});
  }
}

let make = PropertiesPageRelayFeatureGate;

let $$default = PropertiesPageRelayFeatureGate;

exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* react Not a pure module */
